module.exports = __webpack_public_path__ + "static/Certino-f34bb31155d42a5a2ea355a6cd3a16d5.jpg";